/**
 * Text used in the applicant info page.
 */
export const ApplicantInfoMessages = {
    licenseeNameChange:
        'If the Licensee name is being updated, is the update a result from the sale (or transfer of control) of the license(s) to another party and for which proper Commission approval has not been received or proper notification not provided?',
};
